import React, { useState, useRef } from 'react';

const LayoutFooter = ({ translations = {} }) => {
  const [showFace, setShowFace] = useState(false);
  const [faceType, setFaceType] = useState('normal'); // 'normal' o 'scared'
  const [hasInteracted, setHasInteracted] = useState(false);
  const animationRef = useRef(null);
  const timeoutRef = useRef(null);

  // Mostrar rostro periódicamente si no ha habido interacción
  React.useEffect(() => {
    if (!hasInteracted) {
      animationRef.current = setInterval(() => {
        setFaceType('normal');
        setShowFace(true);
        timeoutRef.current = setTimeout(() => setShowFace(false), 1000);
      }, 5000);
    }

    return () => {
      clearInterval(animationRef.current);
      clearTimeout(timeoutRef.current);
    };
  }, [hasInteracted]);

  const handleFaceClick = () => {
    if (hasInteracted) return;

    // Limpiar animaciones automáticas
    clearInterval(animationRef.current);
    clearTimeout(timeoutRef.current);

    // Mostrar rostro asustado
    setFaceType('scared');
    setShowFace(true);

    // Reproducir sonido
    new Audio('/sounds/rostrogrito.mp3').play().catch(console.error);

    // Después de 1 segundo: DESAPARECER TODO Y MARCAR COMO INTERACTUADO
    timeoutRef.current = setTimeout(() => {
      setShowFace(false);
      setHasInteracted(true);
    }, 1000);
  };

  return (
    <>
      {/* CDN para Font Awesome (carga icons online) */}
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css" integrity="sha512-DTOQO9RWCH3ppGqcWaEA1BIZOC6xxalwEsw9c2QQeAIftl+Vegovlnee1c9QX4TctnWMn13TZye+giMm8e2LwA==" crossorigin="anonymous" referrerpolicy="no-referrer" />
      
      <footer className="bg-[#E8715A] py-10 text-white relative overflow-hidden">
        {/* Contenedor del rostro - SOLO SI NO HA INTERACTUADO */}
        {!hasInteracted && (
          <div 
            className={`absolute bottom-0 left-0 w-16 h-16 flex items-center justify-center cursor-pointer z-50 transition-all duration-300 ${
              showFace ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-full'
            }`}
            onClick={handleFaceClick}
            onTouchStart={handleFaceClick}
          >
            <img
              src={faceType === 'scared' ? '/images/rostro2.png' : '/images/rostro1.png'}
              alt="Peeking face"
              className="w-full h-auto object-contain"
              draggable="false"
            />
          </div>
        )}

        {/* Contenido del footer */}
        <div className="container mx-auto px-4 text-center relative z-10">
          <div className="flex justify-center space-x-8 mb-6">
            {/* Email icon */}
            <a
              href="mailto:ellatino.cafebar@gmail.com"
              className="w-12 h-12 flex items-center justify-center"
              title="Email"
            >
              <i className="fas fa-envelope text-2xl text-white" style={{ fontSize: '48px' }}></i>
            </a>

            {/* Instagram icon */}
            <a
              href="https://instagram.com/el_latino_cafe_bar"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 flex items-center justify-center"
              title="Instagram"
            >
              <i className="fab fa-instagram text-2xl text-white" style={{ fontSize: '48px' }}></i>
            </a>

            {/* Facebook icon */}
            <a
              href="https://facebook.com/ellatinocafebar"
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 flex items-center justify-center"
              title="Facebook"
            >
              <i className="fab fa-facebook-f text-2xl text-white" style={{ fontSize: '48px' }}></i>
            </a>

            {/* Phone icon */}
            <a
              href="tel:+302109575737"
              className="w-12 h-12 flex items-center justify-center"
              title="Llamar"
            >
              <i className="fas fa-phone text-2xl text-white" style={{ fontSize: '48px' }}></i>
            </a>
          </div>
          <p className="text-sm">
            &copy; {new Date().getFullYear()} El Latino. {translations.allRightsReserved || 'All rights reserved.'}
          </p>
        </div>
      </footer>
    </>
  );
};

export default LayoutFooter;